export const ExternalRoutes = {
    portal: 'https://test-iportal.vetiva.com'
}

export type ExternalRoutes = typeof ExternalRoutes[keyof typeof ExternalRoutes];
